export const momentumShortDesc: string = '4-month growth rate vs. previous 4-month growth rate (%), ((actual 4 month) / (previous 4 month))-1, in %';
export const momentumLongDesc: string = '4-month growth rate vs. previous 12-month average (%), ((actual 4 month) / ((previous 12 month)/3))-1, in %';
